import { render, staticRenderFns } from "./SaraiDashboard.vue?vue&type=template&id=119901b9&scoped=true"
import script from "./SaraiDashboard.vue?vue&type=script&lang=js"
export * from "./SaraiDashboard.vue?vue&type=script&lang=js"
import style0 from "./SaraiDashboard.vue?vue&type=style&index=0&id=119901b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119901b9",
  null
  
)

export default component.exports